import { Box } from '@mui/material';
import { ShareExperienceButton } from './ShareExperienceButton';

const Footer = () => {

  return (
    <Box sx={{
      flexShrink: 0,
      display: 'flex',
      justifyContent: 'center',
      padding: '10px',
      paddingBottom: 'calc(10px + env(safe-area-inset-bottom, 0px))',
      backgroundColor: 'appShell.chrome',
      borderTop: theme => `3px solid ${theme.palette.appShell.accent}`,
      gap: '10px',
    }}>
      <ShareExperienceButton />
    </Box>
  );
}

export default Footer;
